import { render, staticRenderFns } from "./EditarDocFiscal.vue?vue&type=template&id=4d1254db"
import script from "./EditarDocFiscal.vue?vue&type=script&lang=js"
export * from "./EditarDocFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports